import { Obj } from '../entity.js'
import { ObjOptions } from './base.js'

export class ItemObj extends Obj<'Item'> {
  readonly typeOf = 'Item' as const

  public constructor(opts: ObjOptions) {
    super({ ...opts, typeOf: 'Item' })
  }
}

export function isItemObj(obj: any): obj is ItemObj {
  return obj.typeOf === 'Item'
}

export class FolderObj extends Obj<'Folder'> {
  readonly typeOf = 'Folder' as const

  public constructor(opts: ObjOptions) {
    super({ ...opts, typeOf: 'Folder' })
  }
}

export function isFolderObj(obj: any): obj is FolderObj {
  return obj.typeOf === 'Folder'
}

export interface PageObjOptions extends ObjOptions {}

export class PageObj extends Obj<'Page'> {
  readonly typeOf = 'Page' as const

  public constructor(opts: PageObjOptions) {
    super({ ...opts, typeOf: 'Page' })
  }
}

export function isPageObj(obj: any): obj is PageObj {
  return obj.typeOf === 'Page'
}
